import { LearnerPageChrome } from "@/pages/learners/page-chrome"
import { StudentProfile } from "@/pages/learners/students/show.page"
import { useShowProps } from "@/pages/learners/students/page-props"

// A school admin's student, in the school workspace: the student's own
// profile body under School Students.
export default function Page() {
  const { student } = useShowProps()

  return (
    <>
      <LearnerPageChrome
        identity={{
          name: `${student.firstName} ${student.lastName}`,
          facts: [student.schoolName],
        }}
      />
      <StudentProfile />
    </>
  )
}
